(() => {
  'use strict';

  const ROOT_SELECTOR = '[data-dv-collection-deals]';
  const SLIDE_SELECTOR = '[data-dv-collection-deal-slide]';
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  function hydrateSlideImage(slide) {
    const template = slide && slide.querySelector(
      '[data-dvc-image-template]'
    );
    if (!template) return;
    const fragment = template.content.cloneNode(true);
    template.after(fragment);
    template.remove();
  }

  function connect(root) {
    if (root.dataset.dvcReady === 'true') return;
    root.dataset.dvcReady = 'true';

    const slides = Array.from(root.querySelectorAll(SLIDE_SELECTOR));
    if (!slides.length) return;
    const dots = Array.from(root.querySelectorAll('[data-dvc-dot]'));
    const previous = root.querySelector('[data-dvc-prev]');
    const next = root.querySelector('[data-dvc-next]');
    let index = 0;
    let timer = 0;
    let paused = false;
    let visible = false;
    let touchStartX = 0;
    let touchStartY = 0;
    let suppressClick = false;

    root.classList.add('is-enhanced');

    function show(target, userInitiated = false) {
      index = (target + slides.length) % slides.length;
      hydrateSlideImage(slides[index]);
      slides.forEach((slide, slideIndex) => {
        const active = slideIndex === index;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', String(!active));
        slide.inert = !active;
      });
      dots.forEach((dot, dotIndex) => {
        const active = dotIndex === index;
        dot.classList.toggle('is-active', active);
        if (active) dot.setAttribute('aria-current', 'true');
        else dot.removeAttribute('aria-current');
      });
      if (userInitiated) restart();
    }

    function stop() {
      if (timer) window.clearInterval(timer);
      timer = 0;
    }

    function start() {
      stop();
      if (
        slides.length < 2 ||
        paused ||
        !visible ||
        document.hidden ||
        reducedMotion.matches
      ) return;
      timer = window.setInterval(() => show(index + 1), 6500);
    }

    function restart() {
      stop();
      start();
    }

    previous?.addEventListener('click', () => show(index - 1, true));
    next?.addEventListener('click', () => show(index + 1, true));
    dots.forEach((dot, dotIndex) => {
      dot.addEventListener('click', () => show(dotIndex, true));
    });

    root.addEventListener('touchstart', (event) => {
      const touch = event.changedTouches[0];
      touchStartX = touch ? touch.clientX : 0;
      touchStartY = touch ? touch.clientY : 0;
    }, { passive: true });
    root.addEventListener('touchend', (event) => {
      const touch = event.changedTouches[0];
      if (!touch) return;
      const distanceX = touch.clientX - touchStartX;
      const distanceY = touch.clientY - touchStartY;
      if (
        Math.abs(distanceX) < 48 ||
        Math.abs(distanceX) <= Math.abs(distanceY)
      ) return;
      suppressClick = true;
      show(index + (distanceX < 0 ? 1 : -1), true);
      window.setTimeout(() => {
        suppressClick = false;
      }, 0);
    }, { passive: true });
    root.addEventListener('click', (event) => {
      if (!suppressClick) return;
      event.preventDefault();
      event.stopPropagation();
    }, true);

    root.addEventListener('pointerenter', () => {
      paused = true;
      stop();
    });
    root.addEventListener('pointerleave', () => {
      paused = false;
      start();
    });
    root.addEventListener('focusin', () => {
      paused = true;
      stop();
    });
    root.addEventListener('focusout', () => {
      window.setTimeout(() => {
        if (!root.contains(document.activeElement)) {
          paused = false;
          start();
        }
      }, 0);
    });

    document.addEventListener('visibilitychange', () => {
      if (document.hidden) {
        stop();
      } else {
        start();
      }
    });

    reducedMotion.addEventListener?.('change', () => {
      if (reducedMotion.matches) {
        stop();
      } else {
        start();
      }
    });

    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver((entries) => {
        const entry = entries[0];
        visible = Boolean(entry && entry.isIntersecting);
        root.dataset.dvcVisible = String(visible);
        if (visible) {
          start();
        } else {
          stop();
        }
      }, { threshold: [0, .35] });
      observer.observe(root);
    } else {
      visible = true;
      root.dataset.dvcVisible = 'true';
    }

    show(0);
    start();
  }

  function connectAll() {
    document.querySelectorAll(ROOT_SELECTOR).forEach(connect);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', connectAll, { once: true });
  } else {
    connectAll();
  }
})();
